import type { JsonDataItem } from '../../generic-types';
import { VisibilityConditionBase } from './visibility-condition-base';
import type { VisibilityCondition } from './visibility-condition.interfaces';

export class RecordLinkVisibilityCondition extends VisibilityConditionBase {
  constructor(fieldCondition: VisibilityCondition) {
    super(fieldCondition);
  }

  public runVisibilityCondition(currentData: JsonDataItem): boolean {
    let isHidden = this.defaultIsHidden;

    if (
      this.fieldCondition.sourceFieldId &&
      !currentData[this.fieldCondition.sourceFieldId] &&
      this.fieldCondition.conditionOperator === 'HAS_NONE'
    ) {
      isHidden = false;
    }

    if (this.fieldCondition.sourceFieldId && Array.isArray(currentData[this.fieldCondition.sourceFieldId])) {
      const linkedRecordData = currentData[this.fieldCondition.sourceFieldId] as Array<Record<string, unknown>>;

      if (this.fieldCondition.conditionOperator === 'HAS_ANY') {
        //Check if any record has the same status as the targetvalue
        isHidden = !linkedRecordData.some((data) => data['status'] === this.fieldCondition.targetValue);
      } else if (this.fieldCondition.conditionOperator === 'HAS_ALL') {
        //Check that all records has the same status as the targetvalue
        isHidden = !linkedRecordData.every((data) => data['status'] === this.fieldCondition.targetValue);
      } else if (this.fieldCondition.conditionOperator === 'HAS_NONE') {
        //Check that none of the records has the same status as the targetvalue
        isHidden = linkedRecordData.some((data) => data['status'] === this.fieldCondition.targetValue);
      }
    }

    return isHidden;
  }
}
